/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/LemonsoftIntegrationSettings'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/LemonsoftIntegrationSettings'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.LemonsoftIntegrationSettingsApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.LemonsoftIntegrationSettings);
  }
}(this, function(ApiClient, LemonsoftIntegrationSettings) {
  'use strict';

  /**
   * LemonsoftIntegrationSettings service.
   * @module api/LemonsoftIntegrationSettingsApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new LemonsoftIntegrationSettingsApi. 
   * @alias module:api/LemonsoftIntegrationSettingsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the lemonsoftIntegrationSettingsAddPut operation.
     * @callback module:api/LemonsoftIntegrationSettingsApi~lemonsoftIntegrationSettingsAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/LemonsoftIntegrationSettings} body 
     * @param {module:api/LemonsoftIntegrationSettingsApi~lemonsoftIntegrationSettingsAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.lemonsoftIntegrationSettingsAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling lemonsoftIntegrationSettingsAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling lemonsoftIntegrationSettingsAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/LemonsoftIntegrationSettings/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the lemonsoftIntegrationSettingsDeleteGet operation.
     * @callback module:api/LemonsoftIntegrationSettingsApi~lemonsoftIntegrationSettingsDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/LemonsoftIntegrationSettingsApi~lemonsoftIntegrationSettingsDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.lemonsoftIntegrationSettingsDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling lemonsoftIntegrationSettingsDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling lemonsoftIntegrationSettingsDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/LemonsoftIntegrationSettings/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the lemonsoftIntegrationSettingsEditPut operation.
     * @callback module:api/LemonsoftIntegrationSettingsApi~lemonsoftIntegrationSettingsEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/LemonsoftIntegrationSettings} body 
     * @param {Integer} primaryKey 
     * @param {module:api/LemonsoftIntegrationSettingsApi~lemonsoftIntegrationSettingsEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.lemonsoftIntegrationSettingsEditPut = function(_4SAPIAppID, body, primaryKey, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling lemonsoftIntegrationSettingsEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling lemonsoftIntegrationSettingsEditPut";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling lemonsoftIntegrationSettingsEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/LemonsoftIntegrationSettings/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the lemonsoftIntegrationSettingsSearchSettingsForCurrentCompanyGet operation.
     * @callback module:api/LemonsoftIntegrationSettingsApi~lemonsoftIntegrationSettingsSearchSettingsForCurrentCompanyGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LemonsoftIntegrationSettings} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSettingsForCurrentCompany
     * @param {String} _4SAPIAppID 
     * @param {module:api/LemonsoftIntegrationSettingsApi~lemonsoftIntegrationSettingsSearchSettingsForCurrentCompanyGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LemonsoftIntegrationSettings}
     */
    this.lemonsoftIntegrationSettingsSearchSettingsForCurrentCompanyGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling lemonsoftIntegrationSettingsSearchSettingsForCurrentCompanyGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = LemonsoftIntegrationSettings;

      return this.apiClient.callApi(
        '/LemonsoftIntegrationSettings/searchSettingsForCurrentCompany', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
